<template>
  <div class="modal modal-produto d-block" v-if="opened">
    <div class="modal-content" id="modalProduto" tabindex="-1">
      <div class="border-bottom px-2 py-4 py-md-3">
        <div class="position-relative">
          <a href="javascript:" @click="previusStep()" class="btn position-absolute" style="left: 4px; top: -8px" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto text-center" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
            {{ produto && produto.nome_produto ? produto.nome_produto : ' - ' }}
          </h1>
          <a href="javascript:" @click="closeProduto()" class="btn position-absolute" style="right: 0; top: -8px" aria-label="Voltar" v-if="step >= 0">
            <i class="fa fa-times text-dark"></i>
          </a>
        </div>
      </div>
      <div id="containerProduto" class="container-item" v-if="produto.id_produto && produto.tabelas">
        <div v-if="produto.tabelas.length > 1" v-show="step === 0">
          <div class="topbar-produto">
            <div class="container-fluid">
              <div class="d-flex justify-content-between align-items-center">
                <h6 class="mb-0">Selecione uma opção:</h6>
                <div>
                  <span class="badge badge-primary">Obrigatório</span>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row no-gutters mb-2">
              <div class="col-6 col-md-3 px-1 py-2" v-for="(t, i) in produto.tabelas">
                <a href="javascript:" class="lista-produto shadow-sm" :id="`tabela${i}`" :class="{'selected': t.id_tabela_preco === dados.produto.id_tabela_preco}" @click="selecionarTamanho(t)">
                  <div class="text-produto">{{t.nome_tabela}}</div>
                  <div class="d-flex">
                    <div class="" v-if="t.qtd_estoque <= 20">
                      <span class="badge badge-secondary" v-if="t.qtd_estoque <= 0">Sem estoque</span>
                      <span class="badge border" v-else><b>Estoque: {{t.qtd_estoque | percent}}</b></span>
                    </div>
                    <div class="ml-auto" :class="{'invisible': t.valor <= 0}">
                      <span class="badge badge-primary">{{t.valor | valor}}</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="produto.divisao > 0 && divisoes.length" v-show="step === 1">
          <div id="produtoDivisao" class="topbar-produto">
            <div class="container-fluid">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">Escolha {{produto.divisao}} sabores</h6>
                  <span>Selecionado {{dados.divisoes.length}} de {{produto.divisao}}</span>
                </div>
                <div>
                  <span class="badge badge-light float-right" v-show="dados.divisoes.length === 0">Obrigatório</span>
                  <i class="fa fa-check icon-check" v-show="dados.divisoes.length === parseInt(produto.divisao)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="d-flex justify-content-between mb-2 pb-3 border-bottom" v-if="step === 1">
              <VueFuse :list="divisoes" :fuse-opts="options" :map-results="true" placeholder="Pesquisar sabor.." id="searchDivisao"
                       class="form-control mr-2" @fuse-results="handleResult" @fuse-input="(res) => termDivisao = res" @keyup.native.enter="selecionarDivisaoEnter"/>
              <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
            </div>
            <div class="row no-gutters">
              <div class="col-6 col-md-3 px-1 py-2" v-for="d in searchDivisao">
                <a href="javascript:" class="lista-produto shadow-sm"
                   :class="{'selected': dados.divisoes.includes(d), 'produto-disable' : !dados.produto.id_tabela}" @click="selecionarDivisao(d)">
                  <div class="small text-produto">{{d.nome_produto}}</div>
                  <div class="text-right" :class="{'invisible': d.valor <= 0}">
                    <span class="badge badge-primary">{{d.valor | valor}}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div v-if="modelo === 1 && produto.adicionais && produto.adicionais.length">
          <div v-for="(g, index) in produto.adicionais" v-show="step === (index + 2)" :id="'grupoAdicional' + index">
            <div class="topbar-produto border-bottom pointer">
              <div class="container-fluid">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="mb-0">{{g.nome_grupo}}</h6>
                    <div class="small font-weight-bold" v-if="g.qtd_min > 0 || g.qtd_max > 0">
                      <span v-if="g.qtd_min > 0">Mínimo {{g.qtd_min}}</span>
                      <span v-if="g.qtd_min > 0 && g.qtd_min < g.qtd_max"> e </span>
                      <span v-if="g.qtd_min < g.qtd_max">Máximo {{g.qtd_max}}</span>
                      <div v-if="g.qtd_sel !== '1'">({{g.selecionados}} de {{g.qtd_max}})</div>
                    </div>
                  </div>
                  <div>
                    <div class="text-center">
                      <span class="badge badge-info" v-if="g.qtd_min === '0'">Opcional</span>
                      <span class="badge badge-primary" v-else-if="g.qtd_min > 0 && !(g.selecionados >= g.qtd_min)">Obrigatório</span>
                      <i class="fa fa-check icon-check" v-show="g.qtd_min > 0 && g.selecionados >= g.qtd_min"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div class="d-flex justify-content-between mb-2 pb-3 border-bottom" v-if="step === (index + 2)">
                <VueFuse :list="g.itens" :fuse-opts="options" :map-results="true" placeholder="Pesquisar adicional.."
                         class="form-control mr-2" @fuse-results="handleAdicional" @fuse-input="(res) => termAdd = res" id="searchAdd" @keyup.native.enter="addAdicionaisEnter()"/>
                <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
              </div>
              <div class="row no-gutters">
                <div class="col-6 col-md-3 px-1 py-2" v-for="a in searchAdicional">
                  <div class="lista-produto shadow-sm" :class="{'selected': a.qtd > 0}">
                    <div class="pointer" @click="toggleAdicionais(g, a, index)">
                      <img :src="a.url_imagem" v-if="a.url_imagem" :alt="a.nome_produto"/>
                      <div class="small text-produto">{{a.nome_produto}}</div>
                      <div :class="{'invisible': a.valor <= 0}">
                        <span class="badge badge-primary">+ {{(a.valor * g.qtd_sel) | valor}}</span>
                      </div>
                    </div>
                    <div class="rounded box-qtd">
                      <a href="javascript:" class="botao-qtd-minus" @click="removeAdicionais(g, a, index)">
                        <i class="fa fa-minus"></i>
                      </a>
                      <div class="qtd-output">
                        <input type="tel" class="form-control" v-model="a.qtd" @focus="focusQtd($event)"
                               @blur="changeQtd(g, a, index)" @keydown.enter="changeQtd(g, a, index)" min="0"
                               v-if="g.qtd_max === '0' || parseInt(g.qtd_max) > 7"/>
                        <div class="font-weight-bold" v-else>{{a.qtd}}</div>
                      </div>
                      <a href="javascript:" class="botao-qtd-plus" @click="addAdicionais(g, a, index)">
                        <i class="fa fa-plus"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid" v-if="modelo === 2 && produto.adicionais && produto.adicionais.length" v-show="step === 2">
          <div class="row">
            <div class="col-md-9">
              <div class="pt-3" v-for="(g, index) in produto.adicionais" :id="`grupoAdicional${index}`">
                <div class="topbar-produto rounded pointer px-3 mb-0" @click="toggleGrupo(index)">
                  <div class="w-100 d-flex align-items-center">
                    <div style="width: 24px"><i class="fa" :class="selGrupo === g.id_grupo_adicional ? 'fa-angle-up' : 'fa-angle-down'"></i></div>
                    <div>
                      <h6 class="mb-0">{{g.nome_grupo}}</h6>
                      <div class="small font-weight-bold" v-if="g.qtd_min > 0 || g.qtd_max > 0">
                        <span v-if="g.qtd_min > 0">Mínimo {{g.qtd_min}}</span>
                        <span v-if="g.qtd_min > 0 && g.qtd_min < g.qtd_max"> e </span>
                        <span v-if="g.qtd_min < g.qtd_max">Máximo {{g.qtd_max}}</span>
                        <div v-if="g.qtd_sel !== '1'">({{g.selecionados}} de {{g.qtd_max}})</div>
                      </div>
                    </div>
                    <div class="ml-auto">
                      <div class="text-center">
                        <span class="badge badge-info" v-if="g.qtd_min === '0'">Opcional</span>
                        <span class="badge badge-primary" v-else-if="g.qtd_min > 0 && !(g.selecionados >= g.qtd_min)">Obrigatório</span>
                        <i class="fa fa-check icon-check" v-show="g.qtd_min > 0 && g.selecionados >= g.qtd_min"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3" v-show="selGrupo === index">
                  <div class="d-flex justify-content-between mb-3" v-if="selGrupo === index">
                    <VueFuse :list="g.itens" :fuse-opts="options" :map-results="true" placeholder="Pesquisar adicional.."
                             class="form-control mr-2" @fuse-results="handleAdicional" @fuse-input="(res) => termAdd = res" id="searchAdd2" @keyup.native.enter="addAdicionaisEnter(index)"/>
                    <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
                  </div>
                  <div class="row no-gutters">
                    <div class="col-6 col-md-4 px-1 pb-2" v-for="a in searchAdicional">
                      <div class="lista-produto shadow-sm" :class="{'selected': a.qtd > 0}">
                        <div class="pointer" @click="toggleAdicionais(g, a, index)">
                          <img :src="a.url_imagem" v-if="a.url_imagem" :alt="a.nome_produto"/>
                          <div class="small text-produto">{{a.nome_produto}}</div>
                          <div :class="{'invisible': a.valor <= 0}">
                            <span class="badge badge-primary">{{a.valor | valor}}</span>
                          </div>
                        </div>
                        <div class="rounded box-qtd">
                          <a href="javascript:" class="botao-qtd-minus" @click="removeAdicionais(g, a, index)">
                            <i class="fa fa-minus"></i>
                          </a>
                          <div class="qtd-output">
                            <input type="tel" class="form-control" v-model="a.qtd" @focus="focusQtd($event)"
                                   @blur="changeQtd(g, a, index)" @keydown.enter="changeQtd(g, a, index)" min="0"
                                   v-if="g.qtd_max === '0' || parseInt(g.qtd_max) > 7"/>
                            <div class="font-weight-bold" v-else>{{a.qtd}}</div>
                          </div>
                          <a href="javascript:" class="botao-qtd-plus" @click="addAdicionais(g, a, index)">
                            <i class="fa fa-plus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3 mt-md-3 d-none d-md-block">
              <div class="mb-2" v-if="dados.produto">
                <p class="mb-0 mt-1 small">
                  <b v-if="dados.produto.id_medida === '2'">{{dados.quantidade.toFixed(3)}}kg</b>
                  <b v-else>{{dados.quantidade}}x</b>
                  - {{produto.nome_produto}}
                  <span v-if="dados.produto.nome_tabela">({{dados.produto.nome_tabela}})</span>
                </p>
                <p v-for="d in dados.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</p>
                <p v-for="d in dados.adicionais" class="m-0 pl-2 tamanho-2">
                  + <span v-show="d.qtd > 1">{{d.qtd}}x</span>
                  {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{(d.valor * d.qtd) | valor}}</b></span>
                </p>
                <p class="tamanho-2 font-weight-bold mb-0">Total: {{(dados.valor * dados.quantidade) | valor}}</p>
              </div>
              <hr class="my-3 my-md-2">
              <div class="mb-2">
                <h6 class="font-weight-bold small mb-1">Quantidade</h6>
                <quantidade class="bg-white mb-1" :borda="true" @change="mudarQtd" :max="dados.produto.qtd_estoque" :qtd-inicial="qtdInicial"/>
                <div class="small" v-if="dados.produto.estoque === '1'">
                  <span>Estoque: <b>{{dados.produto.qtd_estoque | percent}}</b></span>
                </div>
              </div>
              <div>
                <h6 class="font-weight-bold small mb-1">Observação</h6>
                <textarea class="form-control" id="obsEditar" rows="4" placeholder="Observação do produto"
                          style="resize: none" v-model="dados.observacao"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div id="observacaoProduto" class="container-fluid" v-show="step === maxStep">
          <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
            <div>Resumo</div>
            <a href="javascript:" @click="goStart()" class="text-info small" v-if="!editar">Editar <i class="fa fa-edit"></i></a>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="card p-2 mb-3" v-if="dados.produto">
                <p class="mb-0 mt-1">
                  <b v-if="dados.produto.id_medida === '2'">{{dados.quantidade.toFixed(3)}}kg</b>
                  <b v-else>{{dados.quantidade}}x</b>
                  - {{produto.nome_produto}}
                  <span v-if="dados.produto.nome_tabela" class="small">({{dados.produto.nome_tabela}})</span>
                </p>
                <p v-for="d in dados.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</p>
                <p v-for="d in dados.adicionais" class="m-0 pl-2 tamanho-2">
                  + <span v-show="d.qtd > 1">{{d.qtd}}x</span>
                  {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{(d.valor * d.qtd) | valor}}</b></span>
                </p>
                <p class="my-1 tamanho-2 font-weight-bold">Total: {{(dados.valor * dados.quantidade) | valor}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card p-2 mb-3 bg-light" v-if="dados.produto">
                <div class="d-flex justify-content-between align-items-center" v-if="dados.produto.id_medida === '2'">
                  <div>
                    <h6 class="m-0 font-weight-bold">Kilo</h6>
                  </div>
                  <div style="width: 150px;">
                    <money v-bind="iptPeso" id="kilo" class="form-control mr-2" @keyup.enter.native="selecionarkilo()" v-model="dados.quantidade"/>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center" v-else>
                  <div>
                    <h6 class="m-0 font-weight-bold">Quantidade</h6>
                    <div class="small" v-if="dados.produto.estoque === '1'">
                      <span>Estoque: <b>{{dados.produto.qtd_estoque | percent}}</b></span>
                    </div>
                  </div>
                  <div style="width: 120px;">
                    <quantidade class="bg-white" :borda="true" @change="mudarQtd" :max="dados.produto.qtd_estoque" :qtd-inicial="qtdInicial"/>
                  </div>
                </div>
              </div>
              <div>
                <hr>
                <div class="h6 mb-1">Observações</div>
                <textarea class="form-control" id="observacoes" rows="3" placeholder="Observações do produto"
                          style="resize: none" v-model="dados.observacao"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-produto border-top">
        <div class="p-2 px-md-3">
          <div class="row no-gutters align-items-center">
            <div class="col-6">
              <button class="btn text-primary py-3" @click="previusStep()">
                <i class="fa fa-chevron-left mr-1"></i> Voltar
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary btn-block py-3" :disabled="btnAvancar < step" @click="nextStep(true)" v-if="step < maxStep">
                <span class="d-flex align-items-center" v-if="dados.valor > 0">
                  {{ (modelo === 1 || editar) ? 'Avançar' : 'Adicionar'}}
                  <span class="ml-auto">{{(dados.valor * dados.quantidade) | valor}}</span>
                </span>
                <span v-else>
                  {{ (modelo === 1 || editar) ? 'Avançar' : 'Adicionar'}} <i class="fa fa-angle-right ml-1"></i>
                </span>
              </button>
              <button class="btn btn-primary btn-block py-3" id="btnAdicionar" @click="adicionarSacola()" v-else>
                <span class="d-flex align-items-center">
                  <i class="fa fa-cart-plus d-none d-sm-inline-block mr-2"></i>
                  <span>{{ editar ? 'Salvar' : 'Adicionar'}}</span>
                  <span class="ml-auto" v-show="dados.valor > 0">{{(dados.valor * dados.quantidade) | valor}}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueFuse from 'vue-fuse'
  import Quantidade from './Quantidade';
  import ProdutoConsumo from "./ProdutoConsumo";
  import Loading from "@/components/gestor/loading";

  export default {
    name: "Produto",
    props: ['sacola', 'token'],
    components: {Loading, ProdutoConsumo, Quantidade, VueFuse},
    data() {
      return {
        btnAvancar: false,
        avancar: true,
        produto: {},
        adicionais: [],
        divisoes: [],
        total: 0,
        editar: true,
        desktop: true,
        opened: false,
        dados: {
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        },

        step: 0,
        maxStep: 6,

        termDivisao: '',
        termAdd: '',
        options: {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: ["nome_produto", "ref_produto", "nome_tabela"]
        },
        searchDivisao: [],
        searchAdicional: [],
        modelo: 1,
        qtdInicial: 1,
        selGrupo: null,

        iptPeso: {
          decimal: '.',
          thousands: '',
          prefix: 'Kg ',
          suffix: '',
          precision: 3,
          masked: false
        },
      }
    },

    methods: {
      getProduto(dados, cache, callback) {
        this.avancar = true;
        this.selGrupo = null;
        this.btnAvancar = -1;
        this.step = 0;
        this.total = 0;
        this.produto = {};
        this.adicionais = [];
        this.dados = {
          id_produto: dados.id_produto,
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        };

        if (cache) {
          this.produto = JSON.parse(JSON.stringify(cache));
          this.maxStep = this.produto.adicionais.length + 2;

          this.$nextTick(() => {
            if (this.produto.adicionais.length === 1) {
              this.toggleGrupo(0);
            }
          });

          callback();
          return;
        }

        this.$store.state.load = true;
        const pesquisa = { tipo_pedido: this.sacola.tipo_pedido, pdv: true }

        this.$http.get(this.base_server + 'delivery/' + this.token + '/v2/produto/' + dados.id_produto, { params: pesquisa })
          .then(response => {
            this.$store.state.load = false;

            if (!response.data.id_produto) {
              this.$swal('Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!')
              return;
            }

            this.produto = response.data;
            this.maxStep = this.produto.adicionais.length + 2;

            this.$nextTick(() => {
              if (this.produto.adicionais.length === 1) {
                this.toggleGrupo(0);
              }
            });

            callback();

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data.msg || "Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!");
          });
      },

      handleResult(r) {
        this.searchDivisao = r;
      },

      handleAdicional(r) {
        this.searchAdicional = r;
      },

      limparAdicional(adicionais) {
        this.termAdd = "";
        this.$store.state.load = false;
        this.searchAdicional = adicionais;
        const input = document.getElementById("searchAdd");

        if (input) {
          input.value = "";
          this.$helpers.focusElement('searchAdd');
        }
      },

      limparDivisao() {
        this.termDivisao = "";
        this.$store.state.load = false;
        this.searchDivisao = this.divisoes;
        const input = document.getElementById("searchDivisao");

        if (input) {
          input.value = "";
          this.$helpers.focusElement('searchDivisao');
        }
      },

      selecionarDivisaoValor(somar) {
        let valor = 0;
        if (this.dados.divisoes.length > 0) {
          if (this.produto.tipo_venda === '2') {
            this.dados.divisoes.forEach((d) => {
              valor += parseFloat(d.valor);
            });

            valor = valor / this.dados.divisoes.length;

          } else {
            this.dados.divisoes.forEach((d) => {
              if (valor < parseFloat(d.valor)) {
                valor = parseFloat(d.valor);
              }
            });
          }

          if (somar) {
            this.dados.valor += valor;

          } else {
            this.dados.valor -= valor;
          }
        }
      },

      selecionarDivisao(d, edit) {
        if (this.dados.produto.id_tabela) {
          let divisao = (this.dados.divisoes.length === parseInt(this.produto.divisao));

          if (!this.dados.divisoes.includes(d) && !divisao) {
            this.selecionarDivisaoValor(false);
            this.dados.divisoes.push(d);
            this.selecionarDivisaoValor(true);

          } else if (this.dados.divisoes.includes(d)) {
            let count = 0;
            let index = -1;
            this.dados.divisoes.forEach((obj) => {
              if (obj === d) {
                index = count;
              }
              count++;
            });

            if (index !== -1) {
              this.selecionarDivisaoValor(false);
              this.dados.divisoes.splice(index, 1);
              this.selecionarDivisaoValor(true);
            }

          } else {
            this.$swal('Máximo de sabor permitido: ' + this.produto.divisao + '');
          }

          this.btnAvancar = (this.dados.divisoes.length === parseInt(this.produto.divisao)) ? 1 : 0;

          if (!edit) {
            if (this.btnAvancar === 1 && this.dados.divisoes.length === parseInt(this.produto.divisao)) {
              this.avancarAutomatico();

            } else if (this.termDivisao.trim()) {
              this.$store.state.load = "Aguarde..";
              setTimeout(() => {
                this.limparDivisao();
              }, 800);
            }
          }

        } else {
          this.$swal('Selecione um item antes de selecionar o sabor');
        }
      },

      selecionarDivisaoEnter() {
        if (!this.is_mobile && this.searchDivisao.length === 1) {
          this.selecionarDivisao(this.searchDivisao[0]);
        }
      },

      addAdicionaisEnter(index) {
        if (this.searchAdicional.length === 1) {
          const a = this.searchAdicional[0];
          const g = this.produto.adicionais.find(grupo => grupo.id_grupo_adicional === a.id_grupo_adicional);

          if (g && a) {
            this.addAdicionais(g, a, this.produto.adicionais.indexOf(g));
          }

        } else if (this.modelo === 1) {
          this.nextStep();

        } else if (index >= 0) {
          if (index < (this.produto.adicionais.length - 1)) {
            this.toggleGrupo(++index);

          } else {
            this.toggleGrupo(null);
            this.$helpers.focusElement('obsEditar');
          }
        }
      },

      toggleGrupo(index) {
        this.selGrupo = (this.selGrupo === index) ? -1 : index;

        if (this.selGrupo >= 0) {
          this.$nextTick(() => {
            this.$helpers.scrollToView(`grupoAdicional${index}`);
            this.$helpers.focusElement('searchAdd2', false, true);
          });
        }
      },

      selecionarTamanho(t) {
        if (t.estoque === '1' && parseInt(t.qtd_estoque) <= 0) {
          this.$swal('Sem estoque', 'Este produto está indisponível no momento');
          return;
        }

        this.selecionarDivisaoValor(false);
        this.dados.divisoes = [];

        if (t === this.dados.produto) {
          this.dados.produto = {};
          this.dados.valor -= parseFloat(t.valor);
          this.btnAvancar = -1;

        } else {
          if (this.dados.produto.valor) {
            this.dados.valor -= parseFloat(this.dados.produto.valor);
          }

          this.dados.produto = t;
          this.dados.valor += parseFloat(t.valor);
          this.btnAvancar = 0;

          if (this.produto.divisao > 0 && this.produto.divisoes) {
            this.divisoes = this.produto.divisoes.filter(d => d.id_tabela === t.id_tabela);
            this.searchDivisao = this.divisoes;
          }

          this.nextStep(true, true);
        }
      },

      removeAdicionais(g, a, index, qtdManual) {
        const qtd_sel = parseInt(g.qtd_sel || '1');
        let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (adicional) {
          const qtd = qtdManual ? 0 : (parseInt(adicional.qtd) - qtd_sel);
          adicional.qtd = qtd < 0 ? 0 : qtd;

          if (qtd <= 0) {
            this.dados.adicionais = this.dados.adicionais.filter(obj => obj !== adicional);
          }

          if (qtdManual || qtd < 0) {
            g.selecionados = (this.dados.adicionais.filter((obj) => obj.id_grupo_adicional === g.id_grupo_adicional).map(p => parseInt(p.qtd)).reduce((prev, next) => prev + next, 0));
            this.dados.valor = this.totalizarProduto();

          } else {
            g.selecionados = (g.selecionados - qtd_sel);
            this.dados.valor -= (parseFloat(a.valor) * qtd_sel);
          }

          if (this.modelo === 1) {
            this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
          }
        }
      },

      addAdicionais(g, a, index, qtdManual) {
        const qtd_sel = parseInt(g.qtd_sel || '1');
        const selecionados = qtdManual ? (this.dados.adicionais.filter((obj) => obj.id_grupo_adicional === g.id_grupo_adicional && obj.id_tabela_preco !== a.id_tabela_preco)
            .map(p => parseInt(p.qtd)).reduce((prev, next) => prev + next, 0) + parseInt(a.qtd)) : (parseInt(g.selecionados) + qtd_sel);

        if (g.qtd_max > 0 && selecionados > parseInt(g.qtd_max)) {
          this.$swal("A quantidade máxima para o adicional \"" + g.nome_grupo + "\" é: " + g.qtd_max);

          if (qtdManual) {
            a.qtd = 0;
            this.removeAdicionais(g, a, index, true);
          }

          return;
        }

        let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (parseInt(a.qtd_estoque) < (qtdManual ? parseInt(a.qtd) : ((adicional ? adicional.qtd : 0) + qtd_sel))) {
          this.$swal('Estoque insuficiente');

          if (qtdManual) {
            a.qtd = 0;
            this.removeAdicionais(g, a, index, true);
          }

          return;
        }

        if (!adicional) {
          a.index = index;
          a.id_grupo = g.id_grupo;
          a.qtd = qtdManual ? parseInt(a.qtd) : qtd_sel;
          this.dados.adicionais.push(a);

        } else {
          adicional.qtd = qtdManual ? adicional.qtd : (adicional.qtd + qtd_sel);
        }

        this.dados.valor = qtdManual ? this.totalizarProduto() : (this.dados.valor + (parseFloat(a.valor) * qtd_sel));
        g.selecionados = selecionados;

        if (this.modelo === 1) {
          this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));

          if (g.selecionados === parseInt(g.qtd_max)) {
            this.avancarAutomatico();

          } else if (this.termAdd.trim()) {
            this.$store.state.load = "Aguarde..";
            setTimeout(() => {
              this.limparAdicional(g.itens);
            }, 800);
          }
        }
      },

      toggleAdicionais(g, a, index) {
        const add = this.dados.adicionais.find(g => g.id_grupo_adicional === a.id_grupo_adicional && g.id_tabela_preco === a.id_tabela_preco);

        if (!add) {
          this.addAdicionais(g, a, index);

        } else {
          this.removeAdicionais(g, add, index);
        }
      },

      changeQtd(g, a, index) {
        if (!isNaN(a.qtd) && parseInt(a.qtd) > 0) {
          this.addAdicionais(g, a, index, true);

        } else {
          a.qtd = 0;
          this.removeAdicionais(g, a, index, true);
        }
      },

      focusQtd(el) {
        if (el.currentTarget) {
          el.currentTarget.select();
        }
      },

      totalizarProduto() {
        let valor = parseFloat(this.dados.produto.valor);

        if (this.dados.divisoes.length > 0) {
          valor = this.produto.tipo_venda === '2' ?
              (this.dados.divisoes.map(d => parseFloat(d.valor)).reduce((prev, curr) => prev + curr, 0) / this.dados.divisoes.length)
              : Math.max.apply(Math, this.dados.divisoes.map(d => { return d.valor; }));
        }

        let valorAdicionais = 0;
        this.dados.adicionais.forEach((a) => { valorAdicionais += (parseFloat(a.valor) * a.qtd) });
        return ((valor + valorAdicionais) * this.dados.quantidade);
      },

      validarBtnAdicionar() {
        let tabelaExiste = this.dados.produto.id_tabela_preco;
        let valido = true;

        if (this.modelo === 1) {
          this.produto.adicionais.forEach((g) => {
            if (g.qtd_min > 0 && g.selecionados < parseInt(g.qtd_min)) {
              valido = false;
            }
          });
        }

        let divisao = (this.dados.divisoes.length === parseInt(this.produto.divisao)) || this.divisoes.length === 0;
        return (tabelaExiste && valido && divisao);
      },

      mudarQtd(qtd) {
        this.dados.quantidade = qtd;
      },

      adicionarSacola() {
        if (!this.validarBtnAdicionar()) {
          return;
        }

        if (this.dados.valor <= 0) {
          this.$swal('Este produto está disponível apenas para valores maiores que R$ 0,00').then(() => {
            this.$helpers.focusElement('btnAdicionar');
          });

          return;
        }

        if (this.editar) {
          this.$emit('editarProdSacola', this.dados);

        } else {
          this.$emit('addSacola', this.dados);
        }

        this.closeProduto();
      },

      closeProduto() {
        this.opened = false;
        this.$emit('fechar', null);
      },

      previusStep() {
        this.avancar = false;

        if (this.step > 0) {
          this.step = this.modelo === 2 ? (this.step > 2 ? 2 : (this.produto.divisao === '0' ? 0 : (this.step - 1))) :
              (this.step === 2 && this.produto.divisao === '0' ? 0 : (this.step - 1));
          const index = (this.step - 2);

          if (this.step === 0 && this.produto.tabelas.length === 1) {
            this.closeProduto();

          } else if (this.modelo !== 2 && index >= 0 && this.produto.adicionais.length > index) {
            const g = this.produto.adicionais[index];

            if (g) {
              this.searchAdicional = g.itens;
              this.scroll(document.getElementById("grupoAdicional" + index));
            }
          }

        } else {
          this.closeProduto();
        }
      },

      avancarAutomatico(texto) {
        if (this.avancar) {
          this.$store.state.load = texto || "Avançando..";
          setTimeout(() => {
            this.$store.state.load = false;
            this.nextStep(true);
          }, 250);
        }
      },

      nextStep(scroll, keep) {
        if (this.btnAvancar < this.step || this.step >= this.maxStep) {
          return;
        }

        this.avancar = true;
        this.termDivisao = "";
        this.termAdd = "";
        this.step = (this.step === 0 && this.produto.divisao === '0' ? 2 : (this.step + 1));
        const index = (this.step - 2);

        this.$nextTick(() => {
          if (this.step === 1) {
            this.$helpers.focusElement('searchDivisao');

          } else if (this.modelo === 1 && index >= 0 && this.produto.adicionais.length > index) {
            const g = this.produto.adicionais[index];

            if (g) {
              this.searchAdicional = g.itens;
              this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
              this.$helpers.focusElement('searchAdd');

              if (scroll) {
                this.scroll(document.getElementById("grupoAdicional" + index));
              }
            }

          } else {
            if (this.modelo === 2) {
              this.btnAvancar = this.maxStep - 1;
              this.step = this.step === 3 ? this.maxStep : this.step;
            }

            if (this.desktop && !this.produto.adicionais.length) {
              this.$helpers.focusElement('obsEditar');
            }
          }

          if (this.step === this.maxStep) {
            if (this.dados.adicionais.length) {
              this.dados.adicionais = this.dados.adicionais.sort((a, b) => a.index - b.index);
            }

            keep = keep || this.produto.divisao !== '0';

            if (this.dados.produto.id_medida === '2') {
              this.dados.quantidade = this.editar ? this.dados.quantidade : 0;
              this.$helpers.focusElement('kilo');

            } else if (this.modelo === 2 && this.desktop && !keep) {
              this.adicionarSacola();

            } else {
              this.$helpers.focusElement('observacoes');
            }
          }
        });
      },

      scroll(top) {
        if (top) {
          top.scrollIntoView();
        }
      },

      goStart() {
        this.step = this.produto.tabelas.length > 1 ? 1 : (this.produto.divisao > 0 ? 2 : 3);
        this.previusStep();
      },

      openProduto(produto, novo, callback) {
        this.editar = false;
        this.modelo = this.configs.lista_adicionais === '2' ? 2 : 1;

        this.getProduto(produto, produto.cache, () => {
          const tabelas = this.produto.tabelas || [];
          const adicionais = this.produto.adicionais || [];
          this.desktop = window.innerWidth > 767;
          this.qtdInicial = 1;

          if (this.podeAdicionarDireto(tabelas, adicionais, novo)) {
            this.dados.produto = tabelas[0];

            if (this.dados.produto.estoque === '1' && parseInt(this.dados.produto.qtd_estoque) <= 0) {
              this.$swal('Sem estoque', 'Este produto está indisponível no momento');
              return;
            }

            this.dados.valor += parseFloat(tabelas[0].valor);
            this.$emit('addSacola', this.dados);

          } else {
            this.$helpers.focusElement('modalProduto');
            this.opened = true;

            if (tabelas.length > 1) {
              this.$nextTick(() => {
                this.$helpers.focusElement(`tabela0`);
              });

            } else {
              this.selecionarTamanho(tabelas[0]);
            }
          }

          if (callback) {
            callback(this.produto);
          }
        });
      },

      podeAdicionarDireto(tabelas, adicionais, novo) {
        const isDesktop = this.desktop;
        const hasOneTabela = tabelas.length === 1;
        const isNotNovo = !novo;
        const isNotKg = tabelas[0].id_medida !== '2';
        const adicionaisValidos = this.modelo === 2 ? !adicionais.some(g => parseInt(g.qtd_min || '0', 10) > 0) : adicionais.length === 0;
        const isNotDivisao = this.produto.divisao === '0';

        return (isDesktop && hasOneTabela && isNotNovo && isNotKg && adicionaisValidos && isNotDivisao)
      },

      editarProduto(dados, cache) {
        this.editar = true;
        this.modelo = 2;
        this.desktop = window.innerWidth > 767;
        this.$helpers.focusElement('modalProduto');

        this.getProduto(dados, cache, () => {
          this.$helpers.focusElement('modalProduto');
          this.opened = true;
          const tabela = this.produto.tabelas.find(t => t.id_tabela_preco === dados.produto.id_tabela_preco)

          if (!tabela) {
            this.$swal("Este produto não está disponível para ser editado");
            return;
          }

          this.selecionarTamanho(tabela);

          if (this.produto.divisao > 0 && this.divisoes.length && dados.divisoes) {
            dados.divisoes.forEach(div => {
              const d = this.divisoes.find(t => t.id_tabela_preco === div.id_tabela_preco);

              if (d) {
                if (div.id_dp) {
                  d.id_dp = div.id_dp;
                }

                this.selecionarDivisao(d, true);
              }
            });
          }

          if (dados.adicionais && this.produto.adicionais) {
            dados.adicionais.forEach(adc => {
              const g = this.produto.adicionais.find(g => g.id_grupo_adicional === adc.id_grupo_adicional);

              if (g && g.itens) {
                const a = g.itens.find(a => a.id_tabela_preco === adc.id_tabela_preco);

                if (a) {
                  if (adc.id_dp) {
                    a.id_dp = adc.id_dp;
                  }

                  a.qtd = parseInt(adc.qtd);
                  this.addAdicionais(g, a, this.produto.adicionais.indexOf(g), true);
                }
              }
            });
          }

          this.dados.quantidade = parseFloat(dados.quantidade || '0');
          this.dados.observacao = dados.observacao;
          this.qtdInicial = this.dados.quantidade;
          this.goStart();
        });
      },

      selecionarkilo() {
        this.adicionarSacola();
      }
    },

    computed: {
      configs() {
        return this.$store.state.pdv.json_config;
      }
    }
  }
</script>

<style scoped>
  .modal-produto {
    background-color: rgba(0,0,0,0.5);
    overflow-y: auto;
  }

  .modal-produto .modal-content {
    margin: 0;
    border-radius: 0;
    border: none;
    min-height: 100%;
    padding-bottom: 86px;
  }

  .footer-produto {
    background-color: #FFFFFF;
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
  }

  .icon-check {
    padding-right: 12px;
  }

  .produto-disable {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .topbar-produto {
    background-color: var(--third);
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding: 18px 0;
    color: #ffffff;
  }

  .box-qtd {
    position: relative;
    display: table;
    width: 100%;
    border: 1px solid var(--secondary);
    margin-top: 10px;
  }

  .botao-qtd-minus, .botao-qtd-plus, .qtd-output {
    width: 33.333333%;
    display: table-cell;
    text-align: center;
    padding: 6px 0;
  }

  .botao-qtd-minus, .botao-qtd-plus {
    color: var(--secondary);
  }

  .qtd-output input {
    text-align: center;
    height: 24px;
  }

  .lista-produto {
    display: block;
    border: 1px solid #dee2e6;
    border-radius: 18px;
    padding: 12px;
    color: #858796;
    background-color: var(--light);
  }

  .lista-produto:hover {
    text-decoration: none;
  }

  .lista-produto:focus {
    border-color: var(--primary);
  }

  .lista-produto.selected, .lista-produto.selected .box-qtd {
    border-color: #ffffff;
    background-color: var(--primary);
    color: #ffffff;
  }

  .lista-produto.selected a {
    color: #ffffff;
  }

  .lista-produto img {
    width: 52px;
    height: 52px;
    object-fit: cover;
    border-radius: 4px;
    margin-left: 12px;
    float: right;
  }

  .text-produto {
    height: 50px;
    overflow: hidden;
    line-height: 16px;
    font-size: 14px;
  }

  .tamanho-2 {
    font-size: 12px;
  }

  @media (min-width: 900px) {
    .modal-produto {
      overflow: hidden;
    }

    .modal-produto .modal-content {
      max-width: 97%;
      margin: 18px auto 0;
      min-height: auto;
      border-radius: 5px;
      padding-bottom: 0;
    }

    .container-item {
      padding-bottom: 12px;
      height: calc(100vh - 180px);
      overflow: auto;
    }

    .footer-produto {
      background-color: transparent;
      position: static;
    }
  }

  @media (min-width: 1200px) {
    .modal-produto .modal-content {
      max-width: 1190px;
    }
  }
</style>
